import { render, staticRenderFns } from "./AdvancedInputPreview.vue?vue&type=template&id=0c671b33&scoped=true"
import script from "./AdvancedInputPreview.vue?vue&type=script&lang=js"
export * from "./AdvancedInputPreview.vue?vue&type=script&lang=js"
import style0 from "./AdvancedInputPreview.vue?vue&type=style&index=0&id=0c671b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c671b33",
  null
  
)

export default component.exports